import { FilterButton } from "@/components/dataPages";
import { capitalizeFirstLetter } from "@/utils/text";
import { ConfidenceLevel } from "@/components/common/svgs/ConfidenceLevel";

export const VolumeButton = ({ value, onClick, active, disabled, level }) => {
    return (
        <FilterButton onClick={onClick} active={active} disabled={disabled}>
            <span className="inline-flex flex-row gap-1 items-center">
                <ConfidenceLevel level={level} />
                {capitalizeFirstLetter(value)}
            </span>
        </FilterButton>
    );
};
